import { Layout, CtaForm } from '../../components';
import ReactPlayer from 'react-player';
import { QUICK_SET_UP } from '../../constants';

export default function QuickSetup() {
	return (
		<Layout pageName='Quick Set Up'>
			<div className='resource-page resource-page--quick-setup'>
				<section className='heading-container'>
					<div className='container'>
						<div className='heading heading--unset-mw'>
							<h1 className='heading__title'>Quick Set Up</h1>
							<h2 className='heading__desc'>FacilityBot can be set up for Fault Reporting within 3 minutes !</h2>
							<h2 className='heading__desc'>Check out the video below to see how this can be done.</h2>
						</div>
					</div>
				</section>

				<section className='feature-video'>
					<div className='container'>
						<div className='player-wrapper'>
							<ReactPlayer
								className='react-player'
								url={QUICK_SET_UP}
								width='100%'
								height='100%'
							/>
						</div>
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}
